import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getSessionId() {
  let s = sessionStorage.getItem("td_sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("td_sid", s);
  }
  return s;
}

export function track(name) {
  try {
    api.post("/track", { type: "event", name, path: window.location.pathname, session_id: getSessionId() });
  } catch (e) {}
}

export function trackVisit() {
  try {
    api.post("/track", { type: "visit", path: window.location.pathname, session_id: getSessionId() });
  } catch (e) {}
}
